import { rem } from "polished";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}
`;
